import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>© 2025 AussieGiftHub. All Rights Reserved.</p>
        <div className="footer-links">
          <a href="/terms">Terms & Conditions</a>
          <a href="/support">Contact Us</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
